import { ApolloModule } from 'apollo-angular';
import { HttpClientModule } from '@angular/common/http';
import { HttpLinkModule } from 'apollo-angular-link-http';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { GqlService } from './services/gql.service';
import { ToastModule } from '../../shared/toast/toast.module';

@NgModule({
    imports: [
        ApolloModule,
        HttpLinkModule,
        HttpClientModule,

        ToastModule,
    ],
    providers: [
        GqlService,
    ],
    exports: [
        ToastModule,
    ],
})

export class GqlModule {
    public static forRoot(environment, InstanceModel): ModuleWithProviders {
        return {
            ngModule: GqlModule,
            providers: [
                {
                    provide: 'environment',
                    useValue: environment,
                },
                {
                    provide: 'OAuthModel',
                    useClass: InstanceModel,
                }
            ],
        };
    }
}
